import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=a4664f66&scoped=true&"
import script from "./MainTabs.vue?vue&type=script&lang=js&"
export * from "./MainTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4664f66",
  null
  
)

export default component.exports